<form (keyup.arrowright)="changeNextImage()" (keyup.arrowleft)="changePreviousImage()">
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">{{ fileName }}</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div class="modal-body" style="height: 60vh !important">
    @if (customer != undefined) {
      <div class="card shadow-lg">
        <div class="card-body p-1">
          <p class="p-0">
            <strong>{{ customer.Name }}</strong>
          </p>
          <p class="p-0">
            <strong>{{ customer.ICNumberWithDash }} | {{ customer.DOB | date: "dd-MM-yyyy" }}</strong>
          </p>
        </div>
      </div>
    }
    <div style="position: absolute; top: 0%; bottom: 0; left: 0; right: 0">
      <ngx-panzoom [zoomLevels]="8" [freeMouseWheelFactor]="0.005">
        <div style="position: relative">
          <img [src]="image" id="enlargedImage" />
        </div>
      </ngx-panzoom>
    </div>
  </div>
  <div class="modal-footer">
    @if (fileList.length > 1 && fileList != undefined) {
      <div class="d-flex align-items-left justify-content-start">
        <button class="btn btn-dark" (click)="changePreviousImage()"><i class="fas fa-caret-left"></i></button>
        <button class="btn btn-dark ms-1" (click)="changeNextImage()"><i class="fas fa-caret-right"></i></button>
      </div>
    }

    @if (checkCanDelete()) {
      <button class="btn btn-danger" (click)="confirmDeletePicture()"><i class="fas fa-trash-alt"></i> Delete</button>
    }

    <button class="btn btn-dark" (click)="rotate()"><i class="fas fa-undo"></i> Rotate</button>
    <p class="text-danger fw-bold">Scroll/Pinch to zoom</p>
  </div>
</form>
